import { AIAgentInputArea } from '@icp/components';
import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// import { isMobile } from '@icp/utils';

function WelcomePage(props) {
  const { t } = useTranslation(['icp-components']);
  const { onStartChat, agentInfo /* , handleSessionSelected */ } = props;
  const aiInputRef = useRef(null);

  return (
    <div className="landing-page-ai-welcome">
      {/* {isMobile() ? null : (
        <div className="landing-page-ai-welcome-left">
          <Suspense fallback={<Loading />}>
            <AIAgentSessionList
              handleSessionSelected={handleSessionSelected}
              isCurrentAgentList={true}
              currentAgentId={agentInfo?.id}
            />
          </Suspense>
        </div>
      )} */}
      <div className="landing-page-ai-welcome-right">
        <div className="landing-page-ai-welcome-main">
          <div className="landing-page-ai-welcome-greeting">
            <div className="landing-page-ai-welcome-greeting-title">
              {t('agent-home.welcome.greeting', { name: agentInfo?.name })}
            </div>
            <div className="landing-page-ai-welcome-greeting-subtitle">
              {t('agent-home.welcome.subtitle')}
            </div>
          </div>
          <div className="ai-agent">
            <AIAgentInputArea
              ref={aiInputRef}
              toolbarConfig={{
                hideModelPicker: true,
                hideGenerate: true,
                hideUpload: true,
                hideSend: !agentInfo,
              }}
              onSend={() => onStartChat(aiInputRef?.current?.getPrompt?.())}
              isHeightFixed={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

WelcomePage.propTypes = {
  onStartChat: PropTypes.func,
  // handleSessionSelected: PropTypes.func,
  agentInfo: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
};

export default WelcomePage;
